import React from "react";
import { saveAs } from "file-saver";
import { IconButton, Tooltip } from "@mui/material";
import { CiExport } from "react-icons/ci";
import { useTheme } from "../ThemeContext";
import Swal from "sweetalert2";

// const TableDownloader = ({ columns, rows, fileName = "table_data.csv" }) => {
  // const TableDownloader = ({ columns, rows, fileName = "table_data.csv", tooltip = "Export" }) => {

  const TableDownloader = ({ columns, rows, fileName = "table_data.csv", tooltip = "Export", sx = {}, confirmBeforeDownload = false }) => {
  const { isDarkMode } = useTheme();
  
  // Function to convert data into CSV format and download it
  const downloadCSV = () => {
    if (!rows || rows.length === 0) return;

    // Extract headers from columns array
    const headers = columns.map((col) => col.headerName).join(",");
    // Extract rows data and format it
    const csvRows = rows.map((row) =>
      columns.map((col) => row[col.field] || "").join(",")
    );
    
    // Combine headers and rows for CSV content
    const csvContent = [headers, ...csvRows].join("\n");

    // Create a blob and trigger download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, fileName);
  };

  const handleDownloadClick = async (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (confirmBeforeDownload) {
      // Close any existing popup first
      Swal.close();

      const result = await Swal.fire({
        title: "Export Confirmation",
        text: "Are you sure you want to export?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Export",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#04a189",
        cancelButtonColor: "#d33",
        allowOutsideClick: true,
        allowEscapeKey: true,
        backdrop: true,
      });

      if (result.isConfirmed) {
        downloadCSV();
      }
    } else {
      downloadCSV();
    }
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton 
        onClick={handleDownloadClick} 
        sx={{
          backgroundColor: isDarkMode ? "rgba(67, 105, 255, 0.08)" : "#F1F5FF",
          borderRadius: "50%",
          width: "39px",
          height: "39px",
          color: "rgba(18, 183, 159, 1)",
          "&:hover": {
            backgroundColor: "var(--icon-hover-bg)",
          },
          ...sx
        }}
      >
        <CiExport className="pro-icon-s" />
      </IconButton>
    </Tooltip>
  );
};

export default TableDownloader;
